import UserState from "../UserState";

export default () => UserState.useContainer();
